/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetResultDto } from './GetResultDto';
import {
    GetResultDtoFromJSON,
    GetResultDtoFromJSONTyped,
    GetResultDtoToJSON,
} from './GetResultDto';

/**
 * 
 * @export
 * @interface CreateUpdateResultDto
 */
export interface CreateUpdateResultDto {
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateResultDto
     */
    timestamp?: Date | null;
    /**
     * 
     * @type {GetResultDto}
     * @memberof CreateUpdateResultDto
     */
    result?: GetResultDto | null;
}

/**
 * Check if a given object implements the CreateUpdateResultDto interface.
 */
export function instanceOfCreateUpdateResultDto(value: object): value is CreateUpdateResultDto {
    return true;
}

export function CreateUpdateResultDtoFromJSON(json: any): CreateUpdateResultDto {
    return CreateUpdateResultDtoFromJSONTyped(json, false);
}

export function CreateUpdateResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'result': json['result'] == null ? undefined : GetResultDtoFromJSON(json['result']),
    };
}

export function CreateUpdateResultDtoToJSON(value?: CreateUpdateResultDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp'] as any).toISOString()),
        'result': GetResultDtoToJSON(value['result']),
    };
}

